/*
 * Zentrale Steuerung der Browser-Konsole.
 *
 * ENABLE_CONSOLE_LOGS
 * true  = console.log / debug / info sichtbar
 * false = console.log / debug / info aus
 *
 * IMPORTANT_CONSOLE_LOGS
 * true  = console.warn / error sichtbar
 * false = console.warn / error aus
 */

const ENABLE_CONSOLE_LOGS = true;
const IMPORTANT_CONSOLE_LOGS = true;


/* =========================================================
 * Normale Konsolenausgaben
 * ========================================================= */

if (!ENABLE_CONSOLE_LOGS) {
    console.log = function () {};
    console.debug = function () {};
    console.info = function () {};
}


/* =========================================================
 * Wichtige Konsolenausgaben
 * ========================================================= */

if (!IMPORTANT_CONSOLE_LOGS) {
    console.warn = function () {};
    console.error = function () {};
}


/* =========================================================
 * Optional global verfügbar machen
 * ========================================================= */

window.OZG_CONSOLE_LOGS_ENABLED =
    ENABLE_CONSOLE_LOGS;

window.OZG_IMPORTANT_CONSOLE_LOGS_ENABLED =
    IMPORTANT_CONSOLE_LOGS;